import { render, staticRenderFns } from "./BaaRevisions.vue?vue&type=template&id=ffa81de4&scoped=true&"
import script from "./BaaRevisions.vue?vue&type=script&lang=js&"
export * from "./BaaRevisions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa81de4",
  null
  
)

export default component.exports